<template>
  <div>
    <transition name="el-fade-in-linear">
      <!-- <keep-alive> -->
        <router-view />
      <!-- </keep-alive> -->
    </transition>
  </div>
</template>

<script>
export default {

}
</script>

<style>
</style>